import { toast } from 'sonner';

/**
 * Toast an already-composed sentence as an error.
 *
 * `toastError(err)` in `lib/notify` renders `errors.<CODE>` from the shared
 * catalog, which is right for most failures and wrong for the handful the API
 * qualifies with a `reason` discriminator: "Konflikt — posten har ändrats" is
 * true but tells an operator nothing, while "Enheten används av 3 artiklar…"
 * tells them exactly what to fix. Pages translate the reason themselves and
 * hand the result here.
 */
export function toastMessageError(message: string, options: { id?: string } = {}): void {
  toast.error(message, options);
}
